import React from "react";

const ProgressProvider = ({ valueStart, valueEnd, children }) => {
  const [value, setValue] = React.useState(valueStart);
  React.useEffect(() => {
    setTimeout(() => {
      setValue(valueEnd);
    }, 10);
  }, [valueEnd]);

  return children(value);
};
export default ProgressProvider;
